"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toolbar = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var toolbar = exports.toolbar = ['styleselect bold italic underline | charmap | link unlink | forecolor backcolor | bullist numlist outdent indent | code | cccisdImageResource cccisdTooltip cccisdInformation cccisdIcons'];
var InlineWysiwyg = function InlineWysiwyg(props) {
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, _extends({}, props, {
    component: _cccisdFormik.CccisdWysiwyg,
    type: "input",
    settings: {
      toolbar: toolbar
    }
  }));
};
InlineWysiwyg.propTypes = {
  name: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string
};
var _default = exports["default"] = InlineWysiwyg;